"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classTransformer_1 = require("../classTransformer");
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../Resource"));
const User_1 = __importDefault(require("./User"));
const Office_1 = __importDefault(require("./Office"));
class UserOfficeAffiliation extends Resource_1.default {
}
exports.default = UserOfficeAffiliation;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UserOfficeAffiliation.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ message: "User is required" }),
    (0, classTransformer_1.Type)(() => User_1.default),
    __metadata("design:type", User_1.default)
], UserOfficeAffiliation.prototype, "user", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UserOfficeAffiliation.prototype, "user_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Office is required" }),
    (0, classTransformer_1.Type)(() => Office_1.default),
    __metadata("design:type", Office_1.default)
], UserOfficeAffiliation.prototype, "office", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UserOfficeAffiliation.prototype, "office_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], UserOfficeAffiliation.prototype, "is_primary", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UserOfficeAffiliation.prototype, "role_in_office", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], UserOfficeAffiliation.prototype, "permissions", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UserOfficeAffiliation.prototype, "status", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], UserOfficeAffiliation.prototype, "idnot_sync", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], UserOfficeAffiliation.prototype, "last_sync_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], UserOfficeAffiliation.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], UserOfficeAffiliation.prototype, "updated_at", void 0);
